// extracted by mini-css-extract-plugin
export default {"main_css_us":"FormHeader_main_css_us__6Lx5f","main_css_jp":"FormHeader_main_css_jp__dVjCc"};